import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ContactInfoSection from "./ContactInfoSection";
import ContactForm from "../../components/ContactFrom/ContactForm";

const ContactPage: React.FC = () => {
  return (
    <Fragment>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Contact us" pagesub="Contact us" hideBg />
            <ContactInfoSection />
            <section className="contact">
              <div className="container">
                <div className="xb-contact-form xb-main-contact xb-border">
                  <div className="form-heading text-center mb-30">
                    <h3 className="title">Ready to collaborate with us?</h3>
                    <p className="sub-title clr-white">
                      Who knows where a single message might lead you.
                    </p>
                  </div>

                  <ContactForm/>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ContactPage;